// jQuery has to be on `window` before any jQuery-plugin module is evaluated. Webpacker did this
// with a ProvidePlugin; under Vite the guarantee comes from module ordering instead — ES module
// bodies run in import order, and a module imported first is fully evaluated before the ones after
// it. Keeping the assignment in its own module (rather than as statements at the top of an entry)
// is what makes that ordering hold: statements in an entry body run *after* every import of that
// entry has already been evaluated.
//
// Load-bearing for `@activeadmin/activeadmin` 2.14 (bare top-level `$`) as well as our own code.
import $ from 'jquery'

window.$ = $
window.jQuery = $

export default $
